import { getTimeFromDate } from './getTimeFromDate';
import { parseTimeToDate } from './parseTimeToDate';
export var addMinutes = function addMinutes(time, minutes) {
  var timeDate = parseTimeToDate(time);
  timeDate.setMinutes(timeDate.getMinutes() + minutes);
  return getTimeFromDate(timeDate);
};